<template>
	<div
		class="statistics-inventory-panel"
		:class="panelClass"
	>
		<div class="statistics-panel-title">
			<div class="list-title">
				{{ $t('statistics.inventories_in', { name: row.name }) }}
			</div>
			<button
				v-if="inventory.length"
				type="button"
				class="statistics-panel-action-button"
				@click="$emit('toggle-all-groups')"
			>
				<i class="fas" :class="allGroupsExpanded ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
				<span>{{ allGroupsExpanded ? $t('statistics.collapse_all') : $t('statistics.expand_all') }}</span>
			</button>
			<button
				type="button"
				class="statistics-panel-expand-button"
				:title="expandTitle"
				@click="$emit('toggle-expand')"
			>
				<i class="fas" :class="isExpanded ? 'fa-compress-alt' : 'fa-expand-alt'"></i>
			</button>
		</div>
		<div class="panel-list-header statistics-inventory-header">
			<div class="panel-header-item">{{ $t('statistics.inventory') }}</div>
			<div class="panel-header-item inventory-building">{{ $t('statistics.building') }}</div>
			<div class="panel-header-item inventory-count">{{ $t('statistics.count') }}</div>
			<div class="panel-header-item narrow-count">{{ $t('statistics.flaws') }}</div>
		</div>
		<div
			v-for="inventoryRow in visibleRows"
			:key="inventoryRow.key"
			class="panel-list statistics-inventory-row"
			:class="{
				active: inventoryRow.type === 'item' && selectedItem && selectedItem.id === inventoryRow.item.id,
				'statistics-inventory-row--group': inventoryRow.type === 'group',
				'statistics-inventory-row--child': inventoryRow.type === 'item'
			}"
			@click="$emit('row-click', inventoryRow)"
		>
			<div
				class="panel-list-item inventory-name"
				:class="{ 'inventory-name--group': inventoryRow.type === 'group' }"
				:title="inventoryRow.type === 'item' ? getInventoryName(inventoryRow.item) : inventoryRow.label"
			>
				<i
					v-if="inventoryRow.type === 'group'"
					class="fas statistics-inventory-group-icon"
					:class="isInventoryGroupExpanded(inventoryRow.id) ? 'fa-angle-down' : 'fa-angle-right'"
				></i>
				<span class="inventory-name-text">
					{{ inventoryRow.type === 'group' ? inventoryRow.label : getInventoryName(inventoryRow.item) }}
				</span>
			</div>
			<div
				v-if="inventoryRow.type === 'item'"
				class="panel-list-item inventory-building"
			>
				{{ inventoryRow.type === 'item' ? inventoryRow.item.buildingName || '-' : '' }}
			</div>
			<div
				v-if="inventoryRow.type === 'group'"
				class="panel-list-item inventory-count"
			>
				{{ inventoryRow.type === 'group' ? inventoryRow.count : '' }}
			</div>
			<div class="panel-list-item narrow-count">
				{{ inventoryRow.type === 'group' ? inventoryRow.flawCount : inventoryRow.item.flawCount }}
			</div>
		</div>
		<div v-if="!inventory.length" class="statistics-empty compact">
			{{ $t('statistics.no_inventories_for_selection') }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'StatisticsInventoryPanel',

	props: {
		allGroupsExpanded: {
			type: Boolean,
			default: false
		},
		expandTitle: {
			type: String,
			required: true
		},
		getInventoryName: {
			type: Function,
			required: true
		},
		inventory: {
			type: Array,
			default: () => []
		},
		isExpanded: {
			type: Boolean,
			default: false
		},
		isInventoryGroupExpanded: {
			type: Function,
			required: true
		},
		panelClass: {
			type: [String, Object, Array],
			default: ''
		},
		row: {
			type: Object,
			required: true
		},
		selectedItem: {
			type: Object,
			default: null
		},
		visibleRows: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss" scoped>
.statistics-inventory-header,
.statistics-inventory-row {
	display: grid !important;
	grid-template-columns: minmax(0, 4fr) minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr) !important;
}

.statistics-inventory-row--group {
	.inventory-name {
		grid-column: 1 / span 2 !important;
	}

	.inventory-count {
		grid-column: 3 !important;
	}

	.narrow-count {
		grid-column: 4 !important;
	}
}

.statistics-inventory-row--child {
	grid-template-columns: minmax(0, 5fr) minmax(0, 4fr) minmax(0, 1fr) !important;
}
</style>
